export default __webpack_public_path__ + "static/media/maryam.e07744dc.png";